// extracted by mini-css-extract-plugin
export var border = "_d-7";
export var brand = "_d-s";
export var button = "_d-k";
export var center = "_d-9";
export var centered = "_d-5";
export var closeButton = "_d-b";
export var disabledWrapper = "_d-l";
export var error = "_d-o";
export var extraLarge = "_d-4";
export var extraSmall = "_d-1";
export var fill = "_d-h";
export var footer = "_d-g";
export var footerAction = "_d-i";
export var footerButtons = "_d-j";
export var header = "_d-6";
export var headerWithClose = "_d-c";
export var icon = "_d-n";
export var info = "_d-r";
export var inline = "_d-8";
export var large = "_d-3";
export var main = "_d-d";
export var modal = "_d-0";
export var neutral = "_d-t";
export var noPadding = "_d-f";
export var none = "_d-u";
export var scrollable = "_d-e";
export var small = "_d-2";
export var success = "_d-q";
export var tight = "_d-m";
export var titleIcon = "_d-a";
export var warn = "_d-p";